const errors = {
  email: {
    required: 'Email address is required',
    invalid: 'Invalid email address',
  },
  phone_number: {
    required: 'Phone number is required',
    invalid: 'Invalid phone number',
  },
  password: {
    required: 'Password is required',
    min: 'Password must be at least 8 characters',
  },
  city: {
    required: 'City is required',
  },
  country: {
    required: 'Country is required',
  },
  name: {
    required: 'Name is required',
    fullName: 'Please enter your full name',
  },
};

export default errors;
